// @ts-ignore
import request from "@/utils/request";

// 查询消息platformMsg/hasNoReadMessage
function hasNoReadMessage() {
  return request({
    url: `/material-service/platformMsg/hasNoReadMessage`,
    method: "post",
  });
}
// platformMsg/queryMsgList消息分页查询--对应前端消息分页查询与我的消息分页查询
function queryMsgList(params) {
  return request({
    url: `/material-service/platformMsg/queryMsgList`,
    method: "post",
    data: params,
  });
}
///platformMsg/queryMsg消息查询看接口--对应前端的查看按钮
function queryMsg(params) {
  return request({
    url: `/material-service/platformMsg/queryMsg`,
    method: "post",
    data: params,
  });
}
///platformMsg/modifyMsgReadStatus 消息状态修改接口--对应前端的查看按钮
function modifyMsgReadStatus(params) {
  return request({
    url: `/material-service/platformMsg/modifyMsgReadStatus`,
    method: "post",
    data: params,
  });
}
export { hasNoReadMessage ,queryMsgList,queryMsg,modifyMsgReadStatus};
